module.exports = __webpack_public_path__ + "static/media/check-square.1d8426a4.svg";